(() => {
  const hover = window.matchMedia('(min-width: 750px) and (hover: hover) and (pointer: fine)');
  const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  const reducedPrefetch = connection?.saveData || ['slow-2g', '2g'].includes(connection?.effectiveType);
  const imagePrefetchMargin = reducedPrefetch ? '350px 0px' : '800px 0px';
  const pending = new WeakSet();
  const load = (image, force = false) => {
    if (!image.dataset.speedSrc || (image.hasAttribute('data-speed-hover') && (!hover.matches || navigator.maxTouchPoints > 0))) return;
    const heroSlide = image.closest('hero-slider .swiper-slide');
    if (!force && heroSlide && !heroSlide.classList.contains('swiper-slide-active')) return;
    const media = image.closest('.media');
    if (image.dataset.speedPreview && media) {
      const id = image.closest('[data-media-id]')?.dataset.mediaId;
      const gallery = image.closest('swiper-product-gallery');
      const thumb = Array.from(gallery?.options?.thumbs?.swiper?.el?.querySelectorAll('[data-media-id]') || []).find(slide => slide.dataset.mediaId === id)?.querySelector('img');
      media.style.backgroundImage = 'url(' + JSON.stringify(thumb?.naturalWidth > 1 ? thumb.currentSrc : image.dataset.speedPreview) + ')';
      media.style.backgroundSize = 'cover';
      media.style.backgroundPosition = 'center';
      image.style.opacity = '0';
      image.style.transition = 'none';
    }
    image.addEventListener('load', () => {
      image.classList.remove('lazy');
      image.style.opacity = '';
      if (image.dataset.speedPreview && media) media.style.backgroundImage = '';
    }, { once: true });
    image.closest('picture')?.querySelectorAll('source[data-speed-srcset]').forEach(source => {
      source.srcset = source.dataset.speedSrcset;
      delete source.dataset.speedSrcset;
    });
    if (image.dataset.speedSrcset) image.srcset = image.dataset.speedSrcset;
    image.src = image.dataset.speedSrc;
    delete image.dataset.speedSrc;
    delete image.dataset.speedSrcset;
    observer?.unobserve(image);
  };
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.filter(entry => entry.isIntersecting).forEach(entry => load(entry.target));
  }, { rootMargin: imagePrefetchMargin }) : null;
  const scan = root => {
    const images = root.matches?.('img[data-speed-image]') ? [root] : [];
    images.push(...(root.querySelectorAll?.('img[data-speed-image]') || []));
    images.forEach(image => {
      if (pending.has(image)) return;
      pending.add(image);
      if (observer) observer.observe(image);
      else load(image);
    });
  };
  window.SpeedImages = { load };
  scan(document);
  new MutationObserver(records => {
    records.forEach(record => record.addedNodes.forEach(scan));
  }).observe(document.body, { childList: true, subtree: true });
  hover.addEventListener('change', () => {
    document.querySelectorAll('img[data-speed-hover][data-speed-src]').forEach(image => {
      observer?.unobserve(image);
      if (observer) observer.observe(image);
      else load(image);
    });
  });
})();


